import React, { useState } from "react";
import FinanceTab from "../finance/FinanceTab";
import { getCurrentMonth, addMonths } from "../finance/calc";

// The Ledger section: the editable finance surface, unchanged in behaviour.
// Form state for the add rows lives here; the data and handlers come from
// useEngagement.
export default function LedgerTab({ eng }) {
  const { cfg, finance, upcoming, extras, blockSessions, blockHistory, configProblems, financeActions: a } = eng;
  const currentMonth = getCurrentMonth();
  // Open on the next month when the ledger looks ahead: the current month is done, next month is the invoice in hand.
  const [expandedMonth, setExpandedMonth] = useState((Number(cfg.ledgerLookAhead) || 0) > 0 ? addMonths(currentMonth, 1) : currentMonth);
  const [addingLineItem, setAddingLineItem] = useState(null);
  const [newLineItem, setNewLineItem] = useState({ label: "", rateId: "", bespoke: "", hours: "1" });
  const [addingUpcoming, setAddingUpcoming] = useState(false);
  const [newUpcoming, setNewUpcoming] = useState({ label: "", amount: "" });

  const addFinanceLineItem = (month) => {
    const rate = (cfg.modules.rateCard?.rates || []).find(r => r.id === newLineItem.rateId);
    const amount = newLineItem.bespoke ? parseFloat(newLineItem.bespoke) : (rate ? rate.rate * parseFloat(newLineItem.hours || 1) : 0);
    const label = newLineItem.label || (rate ? rate.label : "");
    if (!label || !amount) return;
    a.addLineItem(month, { label, amount, rateLabel: rate ? `${rate.label} × ${newLineItem.hours}${(rate.unit || "/hr") === "/hr" ? "hr" : ""}` : "Bespoke", ...(newLineItem.billedSeparately ? { billedSeparately: true, status: "to-invoice" } : {}) });
    setNewLineItem({ label: "", rateId: "", bespoke: "", hours: "1" }); setAddingLineItem(null);
  };
  const addUpcomingItem = () => {
    if (!newUpcoming.label || !newUpcoming.amount) return;
    a.addUpcomingItem(newUpcoming.label, parseFloat(newUpcoming.amount));
    setNewUpcoming({ label: "", amount: "" }); setAddingUpcoming(false);
  };
  const confirmThen = (msg, fn) => (...args) => { if (window.confirm(msg(...args))) fn(...args); };

  return (
    <FinanceTab
      cfg={cfg} configProblems={configProblems} finance={finance} upcoming={upcoming} currentMonth={currentMonth}
      expandedMonth={expandedMonth} setExpandedMonth={setExpandedMonth}
      toggleCoaching={a.toggleCoaching}
      addingLineItem={addingLineItem} setAddingLineItem={setAddingLineItem} newLineItem={newLineItem} setNewLineItem={setNewLineItem}
      addFinanceLineItem={addFinanceLineItem}
      deleteLineItem={confirmThen((m, id) => `Remove "${(finance[m]?.lineItems || []).find(x => x.id === id)?.label || "this item"}"? This can't be undone.`, a.deleteLineItem)}
      updateLineItem={a.updateLineItem} moveLineItem={a.moveLineItem}
      addingUpcoming={addingUpcoming} setAddingUpcoming={setAddingUpcoming} newUpcoming={newUpcoming} setNewUpcoming={setNewUpcoming}
      addUpcomingItem={addUpcomingItem}
      deleteUpcomingItem={confirmThen(id => `Remove "${upcoming.find(x => x.id === id)?.label || "this item"}"? This can't be undone.`, a.deleteUpcomingItem)}
      updateUpcomingItem={a.updateUpcomingItem}
      setCoachingDate={a.setCoachingDate} addCoachingSession={a.addCoachingSession}
      deleteCoachingSession={confirmThen((m, id, label) => `Remove "${label}"? This can't be undone.`, a.deleteCoachingSession)}
      blockSessions={blockSessions} blockHistory={blockHistory}
      setBlockSessionStatus={a.setBlockSessionStatus} setBlockSessionDate={a.setBlockSessionDate} addBlockSession={a.addBlockSession}
      deleteBlockSession={confirmThen((id, label) => `Remove the session on ${label}? This can't be undone.`, a.deleteBlockSession)}
      extras={extras} addExtra={a.addExtra} updateExtra={a.updateExtra}
      deleteExtra={confirmThen((id, label) => `Remove "${label}"? This can't be undone.`, a.deleteExtra)}
    />
  );
}
